<template>
  <div class="">
    <div
      v-if="isUnderDevelopment"
      class="w-full flex items-center justify-center bg-opacity-75"
    >
      <a href="mailto:info@herogrow.net">
        <button
          class="px-4 py-2 font-bold text-white bg-blue-500 rounded hover:bg-blue-700"
        >
          Contact Us
        </button>
      </a>
    </div>
    <div v-else class="mx-auto w-full h-fit flex flex-col justify-between">
      <div class="w-full flex flex-col justify-center">
        <div
          class="mx-auto min-h-[100px] w-full flex flex-col justify-center mt-8"
        >
          <router-link to="/login" class="w-[300px] my-auto mx-auto">
            <el-button
              class="mx-auto w-full my-auto bht"
              type="success"
              size="large"
              plain
            >
              ReviewIQ Login
            </el-button>
          </router-link>
          <div class="mx-auto mt-4 w-[300px]">
            <a href="mailto:info@herogrow.net">
              <el-button class="contact-button w-full bht" size="large" plain>
                Request Demo
              </el-button>
            </a>
          </div>
        </div>
      </div>
      <div>
        <!-- <div class="flex justify-center my-20">
          <div class="w-11/12">
            <div class="text-3xl ml-4">Our Process</div>
            <div class="mx-6 mt-6 text-xl">
              Our team leverages decades of experience to create bespoke
              websites and business intelligence tools for brand growth.
            </div>
          </div>
          <div>
            <img
              src="https://i.imgur.com/GN6rqpK.png"
              alt="charts graphic"
              class="w-1/2 mx-auto"
              ref="chartsImage"
            />
          </div>
        </div> -->
        <!--  -->

        <!--  -->

        <!--  -->

        <!--  -->

        <!--  -->
        <div class="hidden flex justify-center border">
          <div>
            <div class="text-3xl ml-4"></div>
            <div class="mx-6 mt-6 text-xl"></div>
          </div>
          <div></div>
        </div>
        <!--  -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const isUnderDevelopment = ref(false);

// const dashboardImage = ref(null);
// const serversImage = ref(null);
// const cloudImage = ref(null);
// const chartsImage = ref(null);
// const buildImage = ref(null);
// const settingsImage = ref(null);

// onMounted(async () => {
//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach((entry) => {
//       if (entry.isIntersecting) {
//         entry.target.classList.remove("");
//         entry.target.classList.add("fade-in");
//       } else {
//         entry.target.classList.remove("fade-in");
//         entry.target.classList.add("");
//       }
//     });
//   });
//   observer.observe(dashboardImage.value);
//   observer.observe(serversImage.value);
//   observer.observe(cloudImage.value);
//   observer.observe(chartsImage.value);
//   observer.observe(buildImage.value);
//   observer.observe(settingsImage.value);
// });
</script>

<style scoped>
/* Style for the contact button when not hovered */
.contact-button {
  background-color: hsla(273, 100%, 34%, 0.429);
  color: #ffffff;
  /* White text */
}

/* Style for the contact button when hovered */
.contact-button:hover {
  background-color: #a474ff;
  /* Purple background */
  color: #ffffff;
  /* White text */
}

.fade-in {
  opacity: 1;
  transition: opacity 2.5s ease-in-out;
}

.fade-out {
  opacity: 0;
  transition: opacity 2.5s ease-in-out;
}

.bht {
  height: 60px;
  transition-property: all;
  transition-duration: 0.5s;
}
</style>
